module.exports = __webpack_public_path__ + "static/media/MKR.c9069209.svg";